<div class="container">
  <div class="row">
    <div class="col-8">
      <h1>Github::repositories</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-8">
        <form (ngSubmit)="getRepositories(user)">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">@</span>
            </div>
            <input 
              [(ngModel)]="user"
              name="user" 
              type="text" class="form-control"
              placeholder="Type username" 
              aria-label="Username"
            >
            <div class="input-group-append" id="button-addon4">
                <button class="btn btn-outline-primary" (onSubmit)="getRepositories(user)" (click)="getRepositories(user)" type="button">Ger repositories</button>
            </div>
        
          </div>
      </form>
    </div>
  </div>
  <div class="row">
      <div class="col-8">
          <app-repos [repos]="repos"></app-repos>
      </div>
    </div>

</div>


